module.exports = __webpack_public_path__ + "img/Logo AgTrace Original-Branco.1e09a70d.svg";